export default {"src":"/_next/static/media/home-stats-1.0cd2459d.svg","height":414,"width":382,"blurWidth":0,"blurHeight":0};